"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.RadioCheckMark = exports.StyledInput = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _modifiers = require("./modifiers");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledInput = _styledComponents.default.div.withConfig({
  displayName: "elements__StyledInput",
  componentId: "sc-1ktbvi9-0"
})(["align-items:center;background:", ";border-radius:2px;border:1px solid ", ";display:inline-flex;flex:0 0 auto;justify-content:center;> *{visibility:hidden;}"], (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _toColorString.default)(_designTokens.color.base.quarterMoon));

exports.StyledInput = StyledInput;

var RadioCheckMark = _styledComponents.default.div.withConfig({
  displayName: "elements__RadioCheckMark",
  componentId: "sc-1ktbvi9-1"
})(["background:currentColor;border-radius:50%;display:block;"]);

exports.RadioCheckMark = RadioCheckMark;

var Container = _styledComponents.default.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-1ktbvi9-2"
})(["align-items:flex-start;display:flex;flex-direction:column;justify-items:center;position:relative;input{&[type='checkbox'],&[type='radio']{box-sizing:border-box;padding:0;}clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute;width:1px;&:focus + label ", "{border-color:", ";box-shadow:inset 0 0 0 2px ", ";}&:checked + label ", " > *{visibility:visible;}", "}label{display:flex;align-items:center;&:hover ", "{border-color:", ";}}", " > *{color:", ";}label span{line-height:1.4;margin-left:", ";}label + *{margin-top:", ";}", ";", ";", ";", ";"], StyledInput, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _toColorString.default)(_objectSpread({}, _designTokens.color.interaction.pacificOcean, {
  alpha: 0.4
})), StyledInput, function (_ref) {
  var indeterminate = _ref.indeterminate;
  return indeterminate && (0, _styledComponents.css)(["& + label ", " > *{visibility:visible;}"], StyledInput);
}, StyledInput, (0, _toColorString.default)(_designTokens.color.interaction.indianOcean), StyledInput, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _rem.default)(10), (0, _rem.default)(10), _modifiers.typeModifiers, _modifiers.sizeModifiers, _modifiers.statusModifiers, _modifiers.disabledModifiers);

exports.Container = Container;